import React from 'react';
import { Field, Section, Toggle, patchSection } from './shared';

export const isHttpsUrl = (v) => {
  if (!v) return true;
  if (/[\s"'<>\x00-\x1f]/.test(v)) return false;
  try { return new URL(v).protocol === 'https:'; } catch { return false; }
};

export default function ScreensTab({ schema, onChange }) {
  const welcome = schema.welcome || {};
  const end = schema.endScreen || {};
  const setW = (patch) => onChange(patchSection(schema, 'welcome', patch));
  const setE = (patch) => onChange(patchSection(schema, 'endScreen', patch));

  return (
    <div className="space-y-4">
      <Section title="Tela de boas-vindas">
        <Toggle checked={welcome.enabled !== false} onChange={(v) => setW({ enabled: v })} label="Exibir tela de boas-vindas" />
        {welcome.enabled !== false && (
          <>
            <Field label="Título">
              <input className="input" maxLength={200} value={welcome.title || ''} onChange={(e) => setW({ title: e.target.value })} />
            </Field>
            <Field label="Texto">
              <textarea className="input" rows={3} maxLength={1000} value={welcome.text || ''} onChange={(e) => setW({ text: e.target.value })} />
            </Field>
            <Field label="Texto do botão">
              <input className="input" maxLength={60} value={welcome.cta || ''} placeholder="Começar" onChange={(e) => setW({ cta: e.target.value })} />
            </Field>
          </>
        )}
      </Section>

      <Section title="Tela final">
        <Field label="Título">
          <input className="input" maxLength={200} value={end.title || ''} placeholder="Obrigado!" onChange={(e) => setE({ title: e.target.value })} />
        </Field>
        <Field label="Texto">
          <textarea className="input" rows={3} maxLength={1000} value={end.text || ''} onChange={(e) => setE({ text: e.target.value })} />
        </Field>
        <Field label="Redirecionar ao concluir (opcional)" hint="URL HTTPS pública. Deixe vazio para ficar na tela final.">
          <input className="input" type="url" placeholder="https://exemplo.com/obrigado" value={end.redirectUrl || ''}
            onChange={(e) => setE({ redirectUrl: e.target.value })} />
          {!isHttpsUrl(end.redirectUrl) && <p className="text-xs text-red-600 mt-1">A URL deve começar com https:// e não conter espaços ou aspas.</p>}
        </Field>
      </Section>
    </div>
  );
}
